import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	HostBinding,
	OnChanges,
	SimpleChanges,
	ViewEncapsulation,
	HostListener,
	Optional
} from "@angular/core";
import { Notification } from "../notification.class";

@Component({
	selector: "notification",
	templateUrl: "./notification.component.html",
	styleUrls: [
		"./notification.component.scss",
		"./notification.component.theme.scss"
	]
})
export class NotificationComponent implements OnInit, OnChanges {
	@Input() notification: Notification;
	@Output() timeUp = new EventEmitter<string>();

	private __interval: any;
	private __1percentTime: number;
	private __mouseState: "in" | "out" = "out";

	_timeLapse = 100;
	_timerState: "pause" | "play" = "play";

	@HostBinding("class") class: string;
	@HostListener("mouseenter") onMouseEnter() {
		this.__mouseState = "in";
		this.__updateTimer();
	}

	@HostListener("mouseleave") onMouseLeave() {
		this.__mouseState = "out";
		this.__updateTimer();
	}

	constructor() {}

	ngOnInit() {
		setTimeout(() => {
			this.__updateTimer();
		}, 100);
	}

	private __updateTimer() {
		const playTimer =
			this.__mouseState === "out" && this._timerState === "play";

		if (playTimer) {
			this.__startTimer();
		} else {
			this.__stopTimer();
		}
	}

	__startTimer() {
		if (this.notification.waitTime) {
			this.__interval = setInterval(() => {
				this._timeLapse -= 1;
				if (this._timeLapse === 0) {
					this.__triggerTimeUp();
				}
			}, this.__1percentTime);
		}
	}

	__stopTimer() {
		if (this.__interval) {
			clearInterval(this.__interval);
		}
	}

	__triggerTimeUp() {
		this.__stopTimer();
		this.timeUp.emit(this.notification.id.toString());
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ("notification" in changes) {
			const notif = <Notification>changes["notification"].currentValue;
			this.class = notif.type.toString();
			this.__1percentTime = (notif.waitTime * 1000) / 100;
		}
	}

	_toggerTimer() {
		if (this._timerState === "play") {
			this._timerState = "pause";
		} else {
			this._timerState = "play";
		}
		this.__updateTimer();
	}

	_close() {
		console.log("close notification : ", this.notification.id);
		this.timeUp.emit(this.notification.id.toString());
	}
}
